module.exports = __webpack_public_path__ + "img/BOS-Logo-dark.665a848d.png";